import {string} from "@src/libs/yup";

export default string().email("Email is invalid").required("Please enter an email address");